export default __webpack_public_path__ + "static/media/g3se0(2).898a96fc.png";